export default function initStub() {
  // makes sure that the nostojs stub is registered
  window.nostojs =
    window.nostojs ||
    (callback => {
      window.nostojs.q = window.nostojs.q || []
      window.nostojs.q.push(callback)
    })
}
